import React, { useState,useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { BtnAlmacenar, BtnActualizar } from "componentes/templates/btn_crud";
import { GET } from 'helpers/request';
import { POST, PUT } from 'helpers/request'
import LanguageHelper from 'helpers/language_helper'
export default function FormSources() {

  const [minispiner, setMinispiner] = useState(true)

  let { id } = useParams();
  // Luego de almacenar, debemos regresar a la pantalla anterior con navlink o history
  let history = useHistory();

  /* Arreglo con las variables para colocar los datos en el formulario */
  const variables = [
    "sou_txt_name",
    "sou_txt_responsable",
    "sou_txt_email",
    "sou_txt_phone",
    "sou_sts_register",
  
  ];

  
  const gestionarCambio = (event) => {
    if (event.target.type === "radio") {
      localStorage.setItem(event.target.name, event.target.value);
    } else {
      localStorage.setItem(event.target.id, event.target.value);
    }
  };

  const actualizarElemento = async (e) => {
    e.preventDefault();

    try {
      const data = await PUT(variables, "indicators/sources",id);
      // console.log(res);
      Verificar(data);
      
    } catch (error) {
      console.log("error", error)
    }
  };


  const Verificar = (result) => {
    let resultado = result;
    if (resultado.status === 201) {
      alert(resultado.messages);
      // limpiar el storage
      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });
      history.push("/intranetIndicators/sourcesList");
    } else {
      // regresó error (normalmente 400), no pasó la validación
      variables.forEach(function (valor) {
        // es el mensaje de error q devuelve la validacion del codeigniter
        if (document.getElementById(valor + "_msj") !== null) {
          let mensaje = resultado[valor];
          document.getElementById(valor + "_msj").classList.remove("is-hidden");
          document.getElementById(valor + "_msj").textContent = mensaje;
        }

      });
    }
  };

  const colocar = (result) => {
    let resultado = result;
    //console.log("Variables %c"+variables,"color:green")
    variables.forEach(function (i) {
      if( document.getElementById(i)!=null)
      {
        document.getElementById(i).value = resultado[i];
      }
        localStorage.setItem(i, resultado[i]);
        setMinispiner(false)
    });
  };

  const gAlmacenar = async (e) => {
    e.preventDefault();
    
    try {
      const data = await POST(variables, "indicators/sources");
      // console.log(res);
      Verificar(data);
      
    } catch (error) {
      console.log("error", error)
    }
  };

useEffect(() => {
  if (id !== "0") {
    const fetcher = async () => {
      const list = await GET(`indicators/sources/${id}`);
      list.error ? console.log("error useEffect ", list.error) : colocar(list);

    };
    fetcher();
  }else{
    variables.forEach(function (valor) {
      localStorage.removeItem(valor);
    });
    setMinispiner(false)
  }
  // eslint-disable-next-line
}, [])

  return (
    <div className="container is-fluid">
      <div className="columns">
        <div className="column is-7 is-offset-1">
          <h3 className="title is-3">
            {id === "0" ? LanguageHelper.getLanguageString('SourcesForm.Title.add') : LanguageHelper.getLanguageString('SourcesForm.Title.upd') }
          </h3>

          <form autoComplete="nope">
            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('SourcesForm.name')}</label>
              <div className="control has-icons-left">
                <textarea
                  
                  placeholder={LanguageHelper.getLanguageString('SourcesForm.name')}
                  className="textarea"
                  id="sou_txt_name"
                  required
                  onChange={gestionarCambio}
                  maxLength="128"
                />
                
              </div>
              <p
                className="is-hidden help is-danger"
                id="sou_txt_name_msj"
              ></p>
            </div>

            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('SourcesForm.responsable')}</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder={LanguageHelper.getLanguageString('SourcesForm.responsable')}
                  className="input"
                  id="sou_txt_responsable"
                  required
                  onChange={gestionarCambio}
                  maxLength="128"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              
            </div>

            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('SourcesForm.email')}</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder={LanguageHelper.getLanguageString('SourcesForm.email')}
                  className="input"
                  id="sou_txt_email"
                  required
                  onChange={gestionarCambio}
                  maxLength="128"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              
            </div>

            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('SourcesForm.telephone')}</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder={LanguageHelper.getLanguageString('SourcesForm.telephone')}
                  className="input"
                  id="sou_txt_phone"
                  required
                  onChange={gestionarCambio}
                  maxLength="32"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              
            </div>

                   
            
            {id === "0" ? (
              <BtnAlmacenar gAlmacenar={gAlmacenar}>{LanguageHelper.getLanguageString('SourcesForm.save')}</BtnAlmacenar>
            ) : (
              <BtnActualizar actualizarElemento={actualizarElemento}>
                {LanguageHelper.getLanguageString('SourcesForm.update')}
              </BtnActualizar>
            )}
          </form>
        </div>
        

      </div>
    </div>
  );
}